import { Reducer } from "redux";

import { ReAuthIcdCodeDispatchTypes } from "../models/dispatchTypes/ICD10";
import { ReAuthIcdCodeActionDispatchTypes } from "../constants/ICD10";
import { ReAuthIcdCodeResponse } from "../models/api/ICD10";

const initialResponse = {
    id: 0,
    typeId: 0,
    fullNameCreated: "",
    icdCodesInfoDto: [
        {
            referralIcdCodeId: 0,
            diagnosisTypeId: 0,
            diagnosisCode: "",
            diagnosisCodeDescription: "",
            icdDiagnosisCodeId: 0,
        },
    ]
};

const initialState: ReAuthIcdCodeResponse = {
    loading: false,
    response: initialResponse,
};

const IcdCodeForReAuthReducer: Reducer<
    ReAuthIcdCodeResponse,
    ReAuthIcdCodeDispatchTypes
> = (state = initialState, action) => {
    switch (action.type) {
        case ReAuthIcdCodeActionDispatchTypes.RE_AUTH_ICD_CODE_INVOKE: {
            return {
                ...state,
                loading: true,
            };
        }
        case ReAuthIcdCodeActionDispatchTypes.RE_AUTH_ICD_CODE_SUCCESS: {
            return {
                ...state,
                response: action.response,
                loading: false,
            };
        }
    }
    return state;
};

export default IcdCodeForReAuthReducer;
